import React, { FC } from 'react';

import ManagerExportPage from '../ManagerExportPage';

export const DownloadUser: FC = () => {
    return <ManagerExportPage />;
};
